import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import './LinkBox.scss';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';

const LinkBox = (props) => {
  const { linkBoxContent, dataLayerName, showFindFa } = props;
  let { link } = linkBoxContent;

  let queryString = DOMPurify.sanitize(window.location.search);
  if (link.includes('startingpoint')) {
    link = link.replace('startingpoint', 'mypriorities');
    if (queryString) {
      queryString = queryString.replaceAll('&amp;', '&').slice(1);
      link = `${link}&${queryString}`;
    }
  }

  return (
    <div
      className={
        showFindFa ? 'linkbox-content find-fa' : 'linkbox-content no-find-fa'
      }
    >
      <h3>{linkBoxContent.header}</h3>
      <div className="linkbox-text-img">
        <div className="linkbox-img-container">
          <img
            src={linkBoxContent.imgSrc}
            className="linkbox-img"
            aria-label={linkBoxContent.ariaLabel}
            alt={linkBoxContent.ariaLabel}
          />
        </div>
        <p>{linkBoxContent.paragraph}</p>
      </div>
      <span>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex="-1"
          data-testid="linkbox-link"
        >
          <div className="linkbox-btn-content">
            <button
              type="button"
              id={linkBoxContent.id}
              className="button button-primary linkbox-button"
              data-testid="linkbox-button"
              onClick={() => addDataLayerTrigger(dataLayerName)}
            >
              {linkBoxContent.buttonText}
            </button>
          </div>
        </a>
      </span>
    </div>
  );
};

LinkBox.defaultProps = {
  dataLayerName: '',
};

LinkBox.propTypes = {
  linkBoxContent: PropTypes.shape({
    header: PropTypes.string,
    paragraph: PropTypes.string,
    buttonText: PropTypes.string,
    id: PropTypes.string,
    link: PropTypes.string,
    imgSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    ariaLabel: PropTypes.string,
  }
  ).isRequired,
  dataLayerName: PropTypes.string,
  showFindFa: PropTypes.bool.isRequired,
};

export default LinkBox;
